export default __webpack_public_path__ + "img/fa7c2190c7afc77379547543f2b64d6a.svg";